var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/lib/TextField.tsx
import { forwardRef as forwardRef3, useState } from "react";
import MuiTextField from "@mui/material/TextField";
import {
  FormHelperText,
  FormLabel,
  InputPropOverrides,
  SelectAccessibilityOverrides,
  SelectPropOverrides
} from "@availity/mui-form-utils";

// ../layout/src/lib/Box.tsx
import { forwardRef } from "react";
import MuiBox from "@mui/material/Box";
import { jsx } from "react/jsx-runtime";
var Box = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(MuiBox, __spreadProps(__spreadValues({}, props), { ref }));
});

// ../layout/src/lib/Container.tsx
import MuiContainer from "@mui/material/Container";
import { jsx as jsx2 } from "react/jsx-runtime";

// ../layout/src/lib/Grid.tsx
import MuiGrid2 from "@mui/material/Grid2";
import { jsx as jsx3 } from "react/jsx-runtime";
var Grid = (args) => {
  return /* @__PURE__ */ jsx3(MuiGrid2, __spreadValues({}, args));
};

// ../layout/src/lib/Stack.tsx
import MuiStack from "@mui/material/Stack";
import { jsx as jsx4 } from "react/jsx-runtime";

// ../typography/src/lib/Typography.tsx
import { forwardRef as forwardRef2 } from "react";
import { default as MuiTypography } from "@mui/material/Typography";
import { jsx as jsx5 } from "react/jsx-runtime";
var Typography = forwardRef2(
  (_a, ref) => {
    var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
    return /* @__PURE__ */ jsx5(MuiTypography, __spreadProps(__spreadValues({}, rest), { ref, children }));
  }
);

// src/lib/TextField.tsx
import { Fragment, jsx as jsx6, jsxs } from "react/jsx-runtime";
var TextFieldFormHelperText = (_a) => {
  var _b = _a, {
    charCount,
    helperText,
    maxLength,
    showCharacterCount
  } = _b, FormHelperTextProps2 = __objRest(_b, [
    "charCount",
    "helperText",
    "maxLength",
    "showCharacterCount"
  ]);
  if (showCharacterCount) {
    return /* @__PURE__ */ jsxs(Grid, { container: true, justifyContent: "space-between", flexWrap: "nowrap", children: [
      /* @__PURE__ */ jsx6(FormHelperText, __spreadProps(__spreadValues({}, FormHelperTextProps2), { sx: { marginRight: "12px" }, children: helperText })),
      /* @__PURE__ */ jsxs(Typography, { variant: "caption", marginTop: "4px", lineHeight: "1.25rem", children: [
        /* @__PURE__ */ jsx6(Typography, { component: "span", variant: "inherit", color: charCount > maxLength ? "error" : "textPrimary", children: charCount || 0 }),
        "/",
        maxLength
      ] })
    ] });
  }
  return /* @__PURE__ */ jsx6(FormHelperText, __spreadProps(__spreadValues({}, FormHelperTextProps2), { children: helperText }));
};
var TextField = forwardRef3((props, ref) => {
  var _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const _a = props, {
    InputProps: InputProps2,
    helpTopicId,
    InputLabelProps,
    FormHelperTextProps: FormHelperTextProps2,
    required,
    SelectProps: SelectProps2,
    inputProps,
    helperText,
    showCharacterCount = false,
    displayOverflowMaxLength = false
  } = _a, rest = __objRest(_a, [
    "InputProps",
    "helpTopicId",
    "InputLabelProps",
    "FormHelperTextProps",
    "required",
    "SelectProps",
    "inputProps",
    "helperText",
    "showCharacterCount",
    "displayOverflowMaxLength"
  ]);
  const [openDetected, setOpenDetected] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const maxLength = (inputProps == null ? void 0 : inputProps.maxLength) || ((_c = (_b = rest.slotProps) == null ? void 0 : _b.htmlInput) == null ? void 0 : _c.maxLength);
  const allReadOnly = (InputProps2 == null ? void 0 : InputProps2.readOnly) || (inputProps == null ? void 0 : inputProps.readOnly) || ((_e = (_d = rest.slotProps) == null ? void 0 : _d.htmlInput) == null ? void 0 : _e.readOnly) || ((_g = (_f = rest.slotProps) == null ? void 0 : _f.input) == null ? void 0 : _g.readOnly);
  const resolvedProps = (props2) => !props2 || Object.keys(props2).length === 0 ? void 0 : props2;
  return /* @__PURE__ */ jsx6(
    MuiTextField,
    __spreadProps(__spreadValues({}, rest), {
      onChange: (event) => {
        setCharCount(event.target.value.length);
        if (rest.onChange) rest.onChange(event);
      },
      helperText: helperText || /* @__PURE__ */ jsx6(Fragment, {}),
      slots: { formHelperText: TextFieldFormHelperText },
      slotProps: {
        input: resolvedProps(__spreadProps(__spreadValues(__spreadValues(__spreadValues({}, InputProps2), InputPropOverrides), (_h = rest.slotProps) == null ? void 0 : _h.input), {
          readOnly: allReadOnly
        })),
        htmlInput: resolvedProps(__spreadProps(__spreadValues(__spreadValues({
          "aria-required": required
        }, inputProps), (_i = rest.slotProps) == null ? void 0 : _i.htmlInput), {
          maxLength: !displayOverflowMaxLength ? maxLength : void 0
        })),
        select: resolvedProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, SelectProps2), SelectPropOverrides), SelectAccessibilityOverrides(openDetected, setOpenDetected, SelectProps2 == null ? void 0 : SelectProps2.open)), (_j = rest.slotProps) == null ? void 0 : _j.select)),
        inputLabel: resolvedProps(__spreadValues(__spreadValues({
          component: FormLabel,
          helpTopicId,
          required,
          shrink: true
        }, InputLabelProps), (_k = rest.slotProps) == null ? void 0 : _k.inputLabel)),
        formHelperText: resolvedProps(__spreadProps(__spreadValues(__spreadValues({
          component: "div"
        }, FormHelperTextProps2), (_l = rest.slotProps) == null ? void 0 : _l.formHelperText), {
          charCount,
          helperText,
          maxLength,
          showCharacterCount
        }))
      },
      ref
    })
  );
});
export {
  TextField
};
